module.exports = __webpack_public_path__ + "img/cancel_black_24dp_new.1c5ff6e2.svg";